﻿import common from "../../common";
import context_ from "../context";
import SearchBox_ from "../../core/SearchBox";

const context = require("../context") as typeof context_;
// const SearchBox = require("../../core/SearchBox") as SearchBox_;

interface ISettings extends common.ISearchBoxConfig {
    /** Permet d'activer le searchbox (default: false) */
    enableSearchBox?: boolean;
}

class DefaultSearchBox implements common.IWebComponent {
    isEnabledSearchBox?: boolean;
    private _isInit = false;
    protected _searchBox?: SearchBox_ | null;
    protected readonly _defaultFiltersFormName = 'DefaultSearchBoxFilters';

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        this.isEnabledSearchBox = s.enableSearchBox === true;

        this.setupSearchBox(s.searchBoxSettings, s.filtersFormName);

        return context.components.add(this);
    }

    destroy() {

        if (this._searchBox) {
            this._searchBox.destroy();
            this._searchBox = null;//DESTROY (TEST)
        }
    }

    getSearchBox() {
        return this._searchBox;
    }

    private setupSearchBox(searchBoxSettings?: common.ISearchBoxSettings, filtersFormName?: string) {
        if (!this.isEnabledSearchBox) {
            this._searchBox = null;//DESTROY (TEST)
            return;
        }

        if (!searchBoxSettings)
            throw "L'argument 'searchBoxSettings' est requis";

        filtersFormName = filtersFormName || filtersFormName === null ? filtersFormName : this._defaultFiltersFormName;

        const pooler = context.components.getPooler();

        this._searchBox = new SearchBox_(searchBoxSettings, filtersFormName, pooler);
    }
}

export = DefaultSearchBox;
